import { CONVERSATION_ID_LENGTH } from './../../constants/dataFrame';

/**
 * Generates a cryptographically secure, random conversation ID.
 *
 * This function creates a fixed-length (e.g. 16-byte) Uint8Array
 * filled with random values using the provided `randomFill` function.
 * 
 * The `randomFill` implementation should be environment-specific:
 * - In browsers: use `crypto.getRandomValues()`
 * - In Node.js: use `crypto.randomFillSync()`
 *
 * This function remains platform-agnostic by accepting the randomness provider as an injected dependency.
 * 
 * @param randomFill - A function that securely fills a Uint8Array with random bytes.
 * @returns A new Uint8Array representing a unique conversation ID.
 */
export function generateRandomConversationId({
  randomFill,
}: {
  randomFill: (target: Uint8Array) => void;
}): Uint8Array {
  const id = new Uint8Array(CONVERSATION_ID_LENGTH);
  randomFill(id);
  return id;
}